import { useForm } from '@mantine/form'
import React from 'react'
import { modals } from '@mantine/modals'
import { Button, Flex, LoadingOverlay, PasswordInput } from '@mantine/core'
import { IRequestUpdatePassword } from '@apiinterface/IUser'
import User from '@api/User'

const FormEditUserPassword = ({
    refresh,
    user_id,
}: {
    refresh: () => {}
    user_id: number
}) => {
    const form = useForm<IRequestUpdatePassword>({
        initialValues: {
            password: '',
            confirmpassword: '',
        },
    })
    const { onSubmit, isLoading } = User.useUpdateUserPassword({
        user_id: user_id,
        form: form,
        aftersuccess: () => {
            modals.closeAll()
            refresh()
        },
    })
    return (
        <form onSubmit={onSubmit}>
            <LoadingOverlay visible={isLoading} overlayProps={{ blur: 2 }} />
            <Flex direction='column' gap='md'>
                <PasswordInput
                    styles={{
                        input: {
                            borderColor: 'var(--mantine-color-gray-2)',
                        },
                    }}
                    {...form.getInputProps('password')}
                    label='รหัสผ่าน:'
                    placeholder='รหัสผ่าน '
                    data-autofocus
                />

                <PasswordInput
                    styles={{
                        input: {
                            borderColor: 'var(--mantine-color-gray-2)',
                        },
                    }}
                    {...form.getInputProps('confirmpassword')}
                    label='ยืนยันรหัสผ่าน:'
                    placeholder='ยืนยันรหัสผ่าน '
                    data-autofocus
                />
                <Button
                    fullWidth
                    type='submit'
                    radius='10px'
                    mt='md'
                    color='#e6007e'
                >
                    ยืนยัน
                </Button>
            </Flex>
        </form>
    )
}

export default FormEditUserPassword
